export default {"src":"/org/_next/static/media/check-calendar.16a61b6e.svg","height":12,"width":11,"blurWidth":0,"blurHeight":0};